import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { UiowaMfkConfig, ConfigToken } from './models/uiowa-mfk-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MfkInputComponent } from './mfk-input/mfk-input.component';
import { MatFormFieldModule, MatInputModule } from '@angular/material';
@NgModule({
  declarations: [MfkInputComponent],
  imports: [CommonModule, FormsModule, DigitOnlyModule, MatFormFieldModule, BrowserAnimationsModule, MatInputModule, FlexLayoutModule],
  exports: [MfkInputComponent]
})
export class UiowaMfkMaterialModule {
  static forRoot(
    config: UiowaMfkConfig = {
      favoriteMfksApiUrl: 'api/myFavoriteMfks'
    }
  ): ModuleWithProviders {
    return {
      ngModule: UiowaMfkMaterialModule,
      providers: [
        {
          provide: ConfigToken,
          useValue: config
        }
      ]
    };
  }
}
